<template lang="pug">
.features.features-home.stats-page
  .columns
    .column.col-result.first-col-result.is-full
      //- .features.address-info(v-if="!addressFound && !isLoadingSameAddress")
      .features.address-info
        .start-info
          .title-mining 
            span Introducing  
            span.pink Accounts
          .title-small
            span Looking for your Address? Go to 
            span.linkable(@click="goTo('/address')") 
              span Address
            span  in the top menu!
      .features-bullets
        .mb-20.coming-soon Coming up soon  🚀
        .mb-20 Some things you will be able to do with your Account:
        ul
          li
            i.fa.fa-check-circle
            span Change the coin you are mining at any moment, with no downtime
          li
            i.fa.fa-check-circle
            span Distribute your hash rate between more than one coin at the same time
          li
            i.fa.fa-check-circle
            span Change your payout addresses at any time
          li
            i.fa.fa-check-circle
            span Set a custom payment threshold for each coin
          //- li
          //-   i.fa.fa-check-circle
          //-   span Remotely manage your workers when using our easy mining app
          li
            i.fa.fa-plus-circle
            span And more!
        .mt-20 
          span Mining to an account won't require a coin name when connecting, just the account name and an optional worker name.
        .mb-20.mt-5
          span Also note that you will still be able to mine directly to an Address, 
          span.w400 balance and stats from Accounts and Addresses will be independant from each other.
        hr
        .suggestions
          .mt-20.suggestions-title Are we missing something, or do you have a feature in mind? 
          .mt-5.suggestions-subtitle
            span Send us an email at 
            a(href="mailto:support@unmineable.com") support@unmineable.com 
            span  and we will see what we can do!
          //- .mb-20.mt-20 Some things proposed by the community:
          //- ul
          //-   li
          //-     i.fa.fa-check-circle
          //-     span Remotely manage your workers when using our easy mining app

</template>

<script>
export default {
  name: 'view_account',
  props: [],
  components: {
  },
  data() {
    return {
    }
  },
  watch: {
  },
  computed: {
  },
  created() {
    let vm = this
    // vm.updateMetaTags()
    vm.$store.dispatch('setPageSelected', 'account')
    // vm.$store.dispatch('validateVersion')
  },
  mounted() {
  },
  sockets: {
  },
  unmounted() {
  },
  methods: {
    goTo(path) {
      let vm = this
      vm.$router.push(path)
    }
  }
}
</script>

<style lang="stylus" scoped>

.start-info
  padding 10px 0px
  margin-bottom: 20px
  .title-small
    font-size 13px
    margin-top -5px
    .linkable
      font-weight 400
      cursor: pointer
      text-decoration: underline
    span, i
      vertical-align: middle
  .title-mining
    font-size: 2.1rem;
    margin-bottom: 5px;
    font-weight: 600;
    span, img
      vertical-align: middle;
    .coin-symbol
      font-weight 700
    img
      margin: 0px 10px;
      width: 28px;
      min-width: 28px;
      display: inline-block;
      vertical-align: middle;
  .info-block
    font-size 14px

.features-bullets
  .coming-soon
    font-weight: 700
  .suggestions
    padding 5px 0px
    .suggestions-title
      font-size 20px
      font-weight: 700
    .suggestions-subtitle
      font-size 17px
  ul
    padding 10px
    font-weight: 400;
    font-size: 17px;
    li
      margin-bottom 5px
      i, span
        vertical-align: middle
      span
        margin-left 10px

// @media (max-width: 550px)
//   .start-info
//     .title-small
//       text-align: center
html.dark, body.dark
  .prev-label, .start-info .title-mining, .features-bullets, .title-small
    color #fff
</style>



// WEBPACK FOOTER //
// View_Account.vue?02df337a